import { GROUP_NAMES, GROUPS, STATE, STATES, type StateMeta } from 'wobbli';
import { HOLIDAY } from 'wobbli/holidays';

export const FAMILIES: { key: string; name: string; states: StateMeta[] }[] = GROUPS.map(g => ({ key: g, name: GROUP_NAMES[g], states: STATES.filter(s => s.group === g) }));
export const variantName = (st: string, v: string) => STATE[st]?.variants.find(x => x.key === v)?.name ?? STATE[st]?.fidgets?.find(x => x.key === v)?.name ?? v;
export const costumeName = (key: string, c: string) => HOLIDAY[key]?.costumes.find(x => x.key === c)?.name ?? '';
export const pick = <T>(list: T[]) => list[Math.floor(Math.random() * list.length)];
export const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
export const times = (n: number) => String(+n.toFixed(2)) + '×';
